<!-- 単一のメニューカード -->
<template>
  <div class="menu">
    <img class="item_img" :src="menu.image_url" />
    <p class="item_name">{{ menu.item_name }}</p>
    <input
      :id="'radio-' + index"
      name="radio"
      type="radio"
      v-model="radioValue"
      :value="menu.item_name"
    />
    <label :for="'radio-' + index" class="radio-label" />
  </div>
</template>

<script>
export default {
  name: "SMenuCard",
  props: {
    menu: {
      type: Object,
      required: true,
    },
    radio: {
      type: String,
      required: false,
      default: null,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    radioValue: {
      get() {
        return this.radio;
      },
      set(value) {
        this.$emit("parent", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  display: flex;
}
.item_img {
  width: 80px;
  height: 80px;
  margin-right: 15px;
}
.item_name {
  width: 79%;
  background: white;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  font-weight: bold;
}

$color1: #f4f4f4;
$color2: #fdc138;
input[type="radio"] {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 80px;
  + .radio-label {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-right: 15px;
    &:before {
      content: "";
      background: $color1;
      border-radius: 100%;
      border: 1px solid darken($color1, 25%);
      display: inline-block;
      width: 1.5em;
      height: 1.5em;
      position: relative;
      top: -0.2em;
      margin-right: 1em;
      vertical-align: top;
      cursor: pointer;
      text-align: center;
      transition: all 250ms ease;
    }
  }
  &:checked {
    + .radio-label {
      &:before {
        background-color: $color2;
        box-shadow: inset 0 0 0 4px $color1;
      }
    }
  }
  &:focus {
    + .radio-label {
      &:before {
        outline: none;
        border-color: $color2;
      }
    }
  }
  &:disabled {
    + .radio-label {
      &:before {
        box-shadow: inset 0 0 0 4px $color1;
        border-color: darken($color1, 25%);
        background: darken($color1, 25%);
      }
    }
  }
  + .radio-label {
    &:empty {
      &:before {
        margin-right: 0;
      }
    }
  }
}
</style>
